import { ComponentPropsWithoutRef, ForwardedRef, forwardRef, useContext } from 'react';
import { LoadingOverlay, LoadingOverlayProps } from '@givebutter/primitives/loading-overlay';
import { useForwardedRef } from '@givebutter/react-util';
import { TableContext } from 'components/table/TableContext';
import { usePersistentTableState } from 'components/table/usePersistentTableState';
import { twMerge } from 'tailwind-merge';

interface TableContentProps extends ComponentPropsWithoutRef<'table'> {
    loadingOverlayProps?: Partial<LoadingOverlayProps>;
}
const TableContent = forwardRef((props: TableContentProps, ref: ForwardedRef<HTMLTableElement>) => {
    const { className = '', role = 'grid', loadingOverlayProps, ...rest } = props;
    const { className: loadingOverlayClassName, ...restLoadingOverlayProps } =
        loadingOverlayProps ?? {};
    const { isLoading } = useContext(TableContext);
    const internalRef = useForwardedRef(ref);
    usePersistentTableState(internalRef);

    return (
        <LoadingOverlay
            isLoading={!!isLoading}
            delay={0}
            className={twMerge('overflow-auto', loadingOverlayClassName)}
            {...restLoadingOverlayProps}
        >
            <table
                data-table-givebutter={''}
                ref={internalRef}
                role={role}
                className={twMerge('w-full border-separate border-spacing-0', className)}
                {...rest}
            />
        </LoadingOverlay>
    );
});

export { TableContent };
export type { TableContentProps };
